// extracted by mini-css-extract-plugin
export default {"hyphens":"BSboE","tooltip":"poYzJ","graphContainer":"pQ06D","yAxisLabel":"ynlfw"};